import React from 'react';
import './TopBanner.css';
import Port from '../../assets/ShipmentBanner.png'
import VerticalBanner from '../../assets/VerticalBanner.png'

const TopBanner = () => {
  return (
    <div className="banner" style={{
      '--image': `url(${Port})`,
      '--image-mobile': `url(${VerticalBanner})`,
      '--background-x-position': 'right',
      '--mobile-content-position': 'flex-start'
    }}>
      <h1 className="banner-title">
        <span className="highlighted-text">
          <p>The ingredients <br/>for success</p>
        </span>
      </h1>
      <p className="banner-description">
      Source success with our globally curated ingredients, chosen to meet high standards and align with market trends. From essentials to specialties, we deliver quality you can trust.</p>
      <div className="banner-button-container">
        <a className="button" href="https://www.pharm-rx.store/" target="_blank" rel="noopener noreferrer">View our Products</a>
      </div>
    </div>
  );
};

export default TopBanner;
